import { useEffect, useState } from 'react';
import classes from 'components/CheckIn/CheckIn.module.scss';
import { createMuiTheme, ThemeProvider, } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import StoreImage from 'assets/svg/store.svg';
import Constants from 'config/constants';
import CurbsideCheckInImage from 'assets/svg/curbside_checkin.svg';
import InStoreCheckInImage from 'assets/svg/in_store_checkin.svg';
import ClosedImage from 'assets/svg/closed.svg';
import Button from '@material-ui/core/Button';
import DissatisfiedImage from 'assets/svg/dissatisfied.svg';
import TimeImage from 'assets/svg/time.svg';
import CallImage from 'assets/svg/call.svg';
import { StoreHours } from 'utils/StoreHours';
import StoreInfo from 'components/StoreInfo/StoreInfo';
import { Format } from 'utils/Format';
import CheckInToggleGroup from 'components/CheckIn/CheckInToggleGroup/CheckInToggleGroup';
import CheckInVehiclePlacement from 'components/CheckIn/CheckInVehiclePlacement/CheckInVehiclePlacement';

export default function Checkin(props) {
	const [statusIcon, setStatusIcon] = useState(null);
	const [altPickup, setAltPickup] = useState(null);
	const [storeOpen, setStoreOpen] = useState(false);
	const [curbsideStoreOpen, setCurbsideStoreOpen] = useState(false);
	const [hoursOpen, setHoursOpen] = useState(false);

	// toggle buttons
    const [checkInDisabled, setCheckInDisabled] = useState(true);
    const [curbsideSecondStep, setCurbsideSecondStep] = useState(false);
    const [vehiclePlacement, setVehiclePlacement] = useState('');
    const [location, setLocation] = useState('');
    const [locationText, setLocationText] = useState('');
    const [typeSelected, setTypeSelected] = useState('');
    const [typeText, setTypeText] = useState('');
    const [colorSelected, setColorSelected] = useState('');
    const [colorText, setColorText] = useState('');

	const storeHours = props.store.hours;
	const curbsideHours = props.store.curbsideHours;
	const daysOfWeek = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

	const buttonTheme = createMuiTheme({
		palette: {
			primary: {
				main: props.pickupWebsite === Constants.COOKIE_GOLF_GALAXY ? "#677406" : (props.pickupWebsite === Constants.COOKIE_PUBLIC_LANDS ? "#002A19" : "#BB5811")
			},
            action: {
			    disabledBackground: '#C8C8C8'
            }
		}
	});

	useEffect(() => {
		if (props.checkInResult) {
			if (props.checkInResult === Constants.CHECK_IN_RESULT_SUCCESS) {
				props.handleCloseCheckIn();
			}
			props.checkInResult === Constants.CHECK_IN_RESULT_CLOSED && setStatusIcon(DissatisfiedImage);
			props.checkInResult === Constants.CHECK_IN_RESULT_FAILED && setStatusIcon(DissatisfiedImage);
		} else if (props.openStatus) {
			props.openStatus === Constants.STORE_STATUS_CLOSED && setStatusIcon(DissatisfiedImage);
		}

		if (props.showCheckIn) {
			verifyCheckInEligibility();
		}
		// eslint-disable-next-line
	}, [props.checkInResult]);

    useEffect(() => {
        if (!typeSelected || /^ *$/.test(typeSelected) || !colorSelected || /^ *$/.test(colorSelected) || (props.checkInType === Constants.CHECK_IN_STORE && (!location || /^ *$/.test(location)))) {
            setCheckInDisabled(true);
        } else if ((curbsideSecondStep && (!vehiclePlacement || /^ *$/.test(vehiclePlacement) || !locationText || /^ *$/.test(locationText)))) {
            setCheckInDisabled(true);
        } else if ((typeSelected === 'Other' && (!typeText || /^ *$/.test(typeText))) || (colorSelected === 'Other' && (!colorText || /^ *$/.test(colorText))) || (props.checkInType === Constants.CHECK_IN_STORE && (location === 'Other' && (!locationText || /^ *$/.test(locationText))))) {
            setCheckInDisabled(true);
        } else {
            setCheckInDisabled(false);
				}
				if (typeSelected === 'Other') {
					props.setOtherSelected(true);
				}
		// eslint-disable-next-line
    }, [props.checkInType, curbsideSecondStep, typeSelected, typeText, colorSelected, colorText, vehiclePlacement, location, locationText]);

	const verifyCheckInEligibility = () => {
		const {openHour, closeHour, openMinutes, closeMinutes} = StoreHours.getOpenTimes(props.checkInType === Constants.CHECK_IN_CURBSIDE ? props.store.curbsideHours : props.store.hours);
		let currHour = new Date().getHours();
		let currMin = new Date().getMinutes();

		// Pickup type not available
		if (StoreHours.verifyCheckInTypeNotAvailable(props.openStatus, props.checkInType)) {
			props.setCheckInResult(Constants.CHECK_IN_RESULT_CLOSED);
			props.openStatus === Constants.STORE_STATUS_CURBSIDE && setAltPickup(Constants.STORE_STATUS_IN_STORE);
			props.openStatus === Constants.STORE_STATUS_IN_STORE && setAltPickup(Constants.STORE_STATUS_CURBSIDE);
			// Pickup hours based on open type used
		} else if (props.store.useStoreHours) {
			if (StoreHours.verifyOutsideOfStoreHours(currHour, openHour, closeHour, currMin, openMinutes, closeMinutes)) {
				props.setCheckInResult(Constants.CHECK_IN_RESULT_CLOSED);
				props.checkInType === Constants.CHECK_IN_CURBSIDE && setAltPickup(Constants.STORE_STATUS_CURBSIDE);
				props.checkInType === Constants.CHECK_IN_STORE && setAltPickup(Constants.STORE_STATUS_IN_STORE);
			}
		}
	};

	const handleHere = () => {
	    if (props.checkInType === Constants.CHECK_IN_CURBSIDE && !curbsideSecondStep) {
	        setCurbsideSecondStep(true);
        } else {
            const {openHour, closeHour, openMinutes, closeMinutes} = StoreHours.getOpenTimes(props.checkInType === Constants.CHECK_IN_CURBSIDE ? props.store.curbsideHours : props.store.hours);
            let currHour = new Date().getHours();
            let currMin = new Date().getMinutes();

            // Pickup type not available
            if (StoreHours.verifyCheckInTypeNotAvailable(props.openStatus, props.checkInType)) {
                props.setCheckInResult(Constants.CHECK_IN_RESULT_CLOSED);
                props.openStatus === Constants.STORE_STATUS_CURBSIDE && setAltPickup(Constants.STORE_STATUS_IN_STORE);
                props.openStatus === Constants.STORE_STATUS_IN_STORE && setAltPickup(Constants.STORE_STATUS_CURBSIDE);
                // Pickup hours based on open type used
            } else if (props.store.useStoreHours) {
                if (!StoreHours.verifyOutsideOfStoreHours(currHour, openHour, closeHour, currMin, openMinutes, closeMinutes)) {
                    props.handleNotifyStore(
                        props.store.location,
                        `${colorSelected === 'Other' ? colorText : colorSelected} ${typeSelected === 'Other' ? typeText : typeSelected}`,
                        location === 'Other' ? locationText : (props.checkInType === Constants.CHECK_IN_CURBSIDE ? Format.addSpotToCurbsideLocation(locationText) : location),
                        vehiclePlacement,
                        props.checkInType
                    );
                } else {
                    props.setCheckInResult(Constants.CHECK_IN_RESULT_CLOSED);
                }
            } else {
                props.handleNotifyStore(
                    props.store.location,
                    `${colorSelected === 'Other' ? colorText : colorSelected} ${typeSelected === 'Other' ? typeText : typeSelected}`,
                    location === 'Other' ? locationText : (props.checkInType === Constants.CHECK_IN_CURBSIDE ? Format.addSpotToCurbsideLocation(locationText) : location),
										vehiclePlacement,
                    props.checkInType
                );
            }
        }
	};

	const handleCheckInSwitch = (type) => {
		setStatusIcon(null);
		setAltPickup(null);
		setStoreOpen(false);
		setCurbsideStoreOpen(false);
		props.setCheckInType(type);
		props.setCheckInResult(null);
	};

	return (
		<div className={classes.CheckInContainer} data-test-id="check-in-main">
			<AppBar className={classes.CheckInAppBar} position="sticky" elevation={0}>
				<Toolbar>
					<div className={classes.LogoTitleContainer}>
						<div className={classes.IconContainer}>
							<img className={classes.IconImage} src={StoreImage} alt="Store"/>
						</div>
						<div className={classes.Title} data-test-id="check-in-title">
							<p className="upper bold body-large-alt" style={{color: "#191F1C"}}>
								{props.checkInType === Constants.CHECK_IN_CURBSIDE && Constants.CHECK_IN_CURBSIDE_TITLE}
								{props.checkInType === Constants.CHECK_IN_STORE && Constants.CHECK_IN_STORE_TITLE}
							</p>
						</div>
					</div>
					<IconButton onClick={props.handleCloseCheckIn} edge="start" style={{color: "#191F1C"}} data-test-id="check-in-close-icon">
						<CloseIcon fontSize="large"/>
					</IconButton>
				</Toolbar>
			</AppBar>
			<div className={classes.Content}>
				<div className={classes.ContentTitle} data-test-id="check-in-content-title">
					{props.openStatus === Constants.STORE_STATUS_CLOSED ?
						<>
							<div className={classes.IconContainer}>
								<img className={classes.IconImage} src={statusIcon} alt="Status"/>
							</div>
							<div className={classes.Title}>
								<p className="bold body-x-large" style={{color: "#191F1C"}}>
									{Constants.STORE_STATUS_CLOSED_TITLE}
								</p>
							</div>
						</>
						:
						<>
							{props.checkInResult ?
								<>
									<div className={classes.IconContainer}>
										<img className={classes.IconImage} src={statusIcon} alt="Status"/>
									</div>
									<div className={classes.Title}>
										<p className="bold body-x-large" style={{color: "#191F1C"}}>
											{props.checkInResult === Constants.CHECK_IN_RESULT_CLOSED && Constants.CHECK_IN_RESULT_CLOSED_TITLE}
											{props.checkInResult === Constants.CHECK_IN_RESULT_FAILED && Constants.CHECK_IN_RESULT_FAILED_TITLE}
										</p>
									</div>
								</>
								:
								<>
									{props.checkInType === Constants.CHECK_IN_CURBSIDE &&
										<div className={classes.CheckInHeaderTileContainer} data-test-id="header-main">
											<div className={classes.CheckInHeaderCard}>
												<div className={classes.CheckInHeaderLogoTitleContainer}>
													<div className={classes.CheckInHeaderIconContainer}>
														<img className={classes.IconImage} src={CurbsideCheckInImage} alt="Curbside Check In"/>
													</div>
													<div className={classes.CheckInHeaderTitle} data-test-id="header-title">
														<h1 className={props.pickupWebsite === Constants.COOKIE_GOLF_GALAXY ? 'titleGG' : (props.pickupWebsite === Constants.COOKIE_PUBLIC_LANDS ? 'titlePL' : 'titleDSG')}>
                                                            {Constants.CHECK_IN_CURBSIDE_CONTENT_TITLE}
														</h1>
													</div>
												</div>
												<div className={classes.CheckInHeaderText} data-test-id="header-message">
													<p className="body-medium">Help us find you by describing your vehicle type and color below.</p>
												</div>
											</div>
										</div>
									}
									{props.checkInType === Constants.CHECK_IN_STORE &&
										<div className={classes.CheckInHeaderTileContainer} data-test-id="header-main">
											<div className={classes.CheckInHeaderCard}>
												<div className={classes.CheckInHeaderLogoTitleContainer}>
													<div className={classes.CheckInHeaderIconContainer}>
														<img className={classes.IconImage} src={InStoreCheckInImage} alt="In Store Check In"/>
													</div>
													<div className={classes.CheckInHeaderTitle} data-test-id="header-title">
														<h1 className={props.pickupWebsite === Constants.COOKIE_GOLF_GALAXY ? 'titleGG' : (props.pickupWebsite === Constants.COOKIE_PUBLIC_LANDS ? 'titlePL' : 'titleDSG')}>Help Us Find You!</h1>
													</div>
												</div>
												<div className={classes.CheckInHeaderText} data-test-id="header-message">
													<p className="body-medium">Help us find you by selecting what you’re wearing, the color and your in store location.</p>
												</div>
											</div>
										</div>
									}
								</>
							}
						</>
					}
				</div>
				<div className={classes.CheckInImage}>
					{props.openStatus === Constants.STORE_STATUS_CLOSED ?
						<>
							<img src={ClosedImage} alt="closed"/>
						</>
						:
						<>
							{props.checkInResult &&
								<>
									{props.checkInResult === Constants.CHECK_IN_RESULT_CLOSED &&
									<img src={TimeImage} alt="time"/>
									}
									{props.checkInResult === Constants.CHECK_IN_RESULT_FAILED &&
									<img src={CallImage} alt="call"/>
									}
								</>
							}
						</>
					}
				</div>
                {!props.checkInResult && !(props.openStatus === Constants.STORE_STATUS_CLOSED) &&
                    <>
                        {curbsideSecondStep ?
                            <CheckInVehiclePlacement
                                location={location}
                                setLocation={setLocation}
                                locationText={locationText}
                                setLocationText={setLocationText}
                                vehiclePlacement={vehiclePlacement}
                                setVehiclePlacement={setVehiclePlacement}
                            />
                            :
                            <CheckInToggleGroup
                                checkInType={props.checkInType}
                                typeSelected={typeSelected}
                                setTypeSelected={setTypeSelected}
                                colorSelected={colorSelected}
                                setColorSelected={setColorSelected}
                                typeTextFieldValue={typeText}
                                setTypeTextFieldValue={setTypeText}
                                colorTextFieldValue={colorText}
                                setColorTextFieldValue={setColorText}
                                location={location}
                                setLocation={setLocation}
                                locationText={locationText}
                                setLocationText={setLocationText}
                            />
                        }
                    </>
                }
				<div className={classes.Description}>
					<div className={classes.DescriptionText} data-test-id="check-in-desc-text">
						<p className="body-large" style={{color: "#191F1C"}}>
							{props.openStatus === Constants.STORE_STATUS_CLOSED ?
								<>
									Our store is <b>temporarily closed</b>  for order pickup. Please <b>check your email</b> for more information. We apologize for any inconvenience this may cause you.
								</>
								:
								<>
									{props.checkInResult &&
										<>
											{props.checkInResult === Constants.CHECK_IN_RESULT_CLOSED &&
											<>
												{props.checkInType === Constants.CHECK_IN_CURBSIDE &&
												<>
													Whoops! Our store is <b>not open for curbside pickup</b>
													{altPickup ?
														<>
															{storeOpen || hoursOpen ?
																<>
																	,&nbsp;but we are <b>open for in store pickup.</b> Do you want to check in for in store pickup below or come back during curbside hours?
																</>
																:
																<>
																	.&nbsp;In store pickup is available at <b>{Format.getOpenTime(storeHours[daysOfWeek[new Date().getDay()]])}.</b>
																</>
															}
														</>
														:
														<>
															.&nbsp;Curbside pickup is available at <b>{Format.getOpenTime(curbsideHours[daysOfWeek[new Date().getDay()]])}.</b>
														</>
													}
												</>
												}
												{props.checkInType === Constants.CHECK_IN_STORE &&
												<>
													Whoops! Our store is <b>not open for in store pickup</b>
													{altPickup ?
														<>
															{curbsideStoreOpen || hoursOpen ?
																<>
																	,&nbsp;but we are <b>open for curbside pickup.</b> Do you want to check in for curbside pickup below or come back during in store hours?
																</>
																:
																<>
																	.&nbsp;Curbside pickup is available at <b>{Format.getOpenTime(curbsideHours[daysOfWeek[new Date().getDay()]])}.</b>
																</>
															}
														</>
														:
														<>
															.&nbsp;In store pickup is available at <b>{Format.getOpenTime(storeHours[daysOfWeek[new Date().getDay()]])}.</b>
														</>
													}
												</>
												}
											</>
											}
											{props.checkInResult === Constants.CHECK_IN_RESULT_FAILED &&
											<>
												Whoops! <b>We fumbled</b> the message to our teammates. Please call the store at
												<b>{props.store.phone.replaceAll('-', '.')}</b>
											</>
											}
										</>
									}
								</>
							}
						</p>
					</div>
				</div>
			</div>
			{props.checkInResult === Constants.CHECK_IN_RESULT_CLOSED &&
			<div className={classes.StoreInfoContainer}>
				<StoreInfo className="item"
									 stores={props.stores}
									 store={props.store}
									 pickupWebsite={props.pickupWebsite}
									 inDialog={true}
									 openStatus={props.openStatus}
									 setStoreOpen={setStoreOpen}
									 setCurbsideStoreOpen={setCurbsideStoreOpen}
									 setHoursOpen={setHoursOpen} />
			</div>
			}
			<div>
				<div className={classes.PhantomFooter} style={props.checkInType === Constants.CHECK_IN_STORE ? {marginTop: "60px"} : {marginTop: "30px"}} />
				<div className={classes.Footer}>
					{props.openStatus === Constants.STORE_STATUS_CLOSED ?
						<>
							<ThemeProvider theme={buttonTheme}>
								<Button className={classes.HereBtn}
												color="primary"
												variant="contained"
												onClick={props.handleCloseCheckIn}>
									<p className="body-large-alt">View Order</p>
								</Button>
							</ThemeProvider>
						</>
						:
						<>
							{props.checkInResult ?
								<>
									{(props.checkInResult === Constants.CHECK_IN_RESULT_CLOSED) &&
									<>
										{altPickup && hoursOpen ?
											<>
												<div>
													<div className={classes.LeftBtnContainer}>
														<Button className={classes.LeftBtn}
																		variant="outlined"
																		onClick={props.handleCloseCheckIn}>
															<p className="body-large-alt">Return Later</p>
														</Button>
													</div>
													<div className={classes.RightBtnContainer}>
														<ThemeProvider theme={buttonTheme}>
															<Button data-test-id="check-in-curbside-alt-pickup-button" className={classes.RightBtn}
                                                                            disabled={
                                                                                (altPickup === Constants.STORE_STATUS_IN_STORE && (storeOpen && !curbsideStoreOpen))
                                                                                ||
                                                                                (altPickup === Constants.STORE_STATUS_CURBSIDE && (!storeOpen && curbsideStoreOpen))
                                                                            }
																			color="primary"
																			variant="contained"
																			onClick={() => handleCheckInSwitch(altPickup === Constants.STORE_STATUS_IN_STORE ? Constants.CHECK_IN_CURBSIDE : Constants.CHECK_IN_STORE)}>
																<p className="body-large-alt">{altPickup === Constants.STORE_STATUS_IN_STORE ? 'I\'m Curbside' : 'I\'m In Store'}</p>
															</Button>
														</ThemeProvider>
													</div>
												</div>
											</>
											:
											<>
												<ThemeProvider theme={buttonTheme}>
													<Button className={classes.HereBtn}
																	color="primary"
																	variant="contained"
																	onClick={props.handleCloseCheckIn}>
														<p className="body-large-alt">View Order</p>
													</Button>
												</ThemeProvider>
											</>
										}
									</>
									}
									{(props.checkInResult === Constants.CHECK_IN_RESULT_FAILED) &&
									<>
										<div>
											<div className={classes.LeftBtnContainer}>
												<Button className={classes.LeftBtn}
																variant="outlined"
																onClick={props.handleCloseCheckIn}>
													<p className="body-large-alt">View Order</p>
												</Button>
											</div>
											<div className={classes.RightBtnContainer}>
												<ThemeProvider theme={buttonTheme}>
													<Button className={classes.RightBtn}
																	color="primary"
																	variant="contained"
																	onClick={handleHere}>
														<p className="body-large-alt">Try Again</p>
													</Button>
												</ThemeProvider>
											</div>
										</div>
									</>
									}
								</>
								:
								<>
									<ThemeProvider theme={buttonTheme}>
										<Button className={classes.HereBtn} data-test-id="check-in-here-btn"
                                                        disabled={checkInDisabled}
                                                        color="primary"
														variant="contained"
														onClick={handleHere}>
											<p className="body-large-alt">{props.checkInType === Constants.CHECK_IN_STORE ? Constants.CHECK_IN_STORE_BUTTON_TEXT : Constants.CHECK_IN_CURBSIDE_BUTTON_TEXT}</p>
										</Button>
									</ThemeProvider>
								</>
							}
						</>
					}
				</div>
			</div>
		</div>
	);
}
